// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as addListActionReducer } from './addListAction';
import { reducer as getPositionTypeListReducer } from './getPositionTypeList';
import { reducer as submitPositionTypeReducer } from './submitPositionType';
import { reducer as deletePositionTypeReducer } from './deletePositionType';
import { reducer as positionTypeModalChangeReducer } from './positionTypeModalChange';
import { reducer as chooseCurrentPositionTypeReducer } from './chooseCurrentPositionType';
import { reducer as getAllPositionTypeReducer } from './getAllPositionType';
import { reducer as getCompanyTypeListReducer } from './getCompanyTypeList';
import { reducer as submitCompanyTypeReducer } from './submitCompanyType';
import { reducer as deleteCompanyTypeReducer } from './deleteCompanyType';
import { reducer as companyTypeModalChangeReducer } from './companyTypeModalChange';
import { reducer as chooseCurrentCompanyTypeReducer } from './chooseCurrentCompanyType';
import { reducer as getAreaListReducer } from './getAreaList';
import { reducer as submitAreaReducer } from './submitArea';
import { reducer as deleteAreaReducer } from './deleteArea';
import { reducer as areaModalChangeReducer } from './areaModalChange';
import { reducer as chooseCurrentAreaReducer } from './chooseCurrentArea';
import { reducer as getEduListReducer } from './getEduList';
import { reducer as submitEduReducer } from './submitEdu';
import { reducer as deleteEduReducer } from './deleteEdu';
import { reducer as eduModalChangeReducer } from './eduModalChange';
import { reducer as chooseCurrentEduReducer } from './chooseCurrentEdu';
import { reducer as getBenefitsListReducer } from './getBenefitsList';
import { reducer as submitBenefitsReducer } from './submitBenefits';
import { reducer as deleteBenefitsReducer } from './deleteBenefits';
import { reducer as benefitsModalChangeReducer } from './benefitsModalChange';
import { reducer as chooseCurrentBenefitsReducer } from './chooseCurrentBenefits';
import { reducer as getCertTypeListReducer } from './getCertTypeList';
import { reducer as submitCertTypeReducer } from './submitCertType';
import { reducer as deleteCertTypeReducer } from './deleteCertType';
import { reducer as certTypeModalChangeReducer } from './certTypeModalChange';
import { reducer as chooseCurrentCertTypeReducer } from './chooseCurrentCertType';
import { reducer as getUserTagListReducer } from './getUserTagList';
import { reducer as submitUserTagReducer } from './submitUserTag';
import { reducer as deleteUserTagReducer } from './deleteUserTag';
import { reducer as userTagModalChangeReducer } from './userTagModalChange';
import { reducer as chooseCurrentUserTagReducer } from './chooseCurrentUserTag';
import { reducer as getAllCertTypeReducer } from './getAllCertType';
import { reducer as getSalaryRangeListReducer } from './getSalaryRangeList';
import { reducer as submitSalaryRangeReducer } from './submitSalaryRange';
import { reducer as deleteSalaryRangeReducer } from './deleteSalaryRange';
import { reducer as salaryRangeModalChangeReducer } from './salaryRangeModalChange';
import { reducer as chooseCurrentSalaryRangeReducer } from './chooseCurrentSalaryRange';
import { reducer as getSalaryTypeListReducer } from './getSalaryTypeList';
import { reducer as submitSalaryTypeReducer } from './submitSalaryType';
import { reducer as deleteSalaryTypeReducer } from './deleteSalaryType';
import { reducer as salaryTypeModalChangeReducer } from './salaryTypeModalChange';
import { reducer as chooseCurrentSalaryTypeReducer } from './chooseCurrentSalaryType';
import { reducer as getAllSalaryTypeReducer } from './getAllSalaryType';
import { reducer as getWorkExperienceListReducer } from './getWorkExperienceList';
import { reducer as submitWorkExperienceReducer } from './submitWorkExperience';
import { reducer as deleteWorkExperienceReducer } from './deleteWorkExperience';
import { reducer as workExperienceModalChangeReducer } from './workExperienceModalChange';
import { reducer as chooseCurrentWorkExperienceReducer } from './chooseCurrentWorkExperience';
import { reducer as getIndustryTypeListReducer } from './getIndustryTypeList';
import { reducer as submitIndustryTypeReducer } from './submitIndustryType';
import { reducer as deleteIndustryTypeReducer } from './deleteIndustryType';
import { reducer as industryTypeModalChangeReducer } from './industryTypeModalChange';
import { reducer as chooseCurrentIndustryTypeReducer } from './chooseCurrentIndustryType';
import { reducer as getAllUserTagReducer } from './getAllUserTag';
import { reducer as getAllCompanyTypeReducer } from './getAllCompanyType';
import { reducer as getAllAreaReducer } from './getAllArea';
import { reducer as getAllIndustryTypeReducer } from './getAllIndustryType';
import { reducer as getAllEduReducer } from './getAllEdu';
import { reducer as getAllExperienceReducer } from './getAllExperience';
import { reducer as getAllBenifitsReducer } from './getAllBenifits';
import { reducer as getPositionCategoryReducer } from './getPositionCategory';
import { reducer as getAllChildPostionReducer } from './getAllChildPostion';
import { reducer as getPositionListwithCaterogyReducer } from './getPositionListwithCaterogy';
import { reducer as addCategoryChildPositionReducer } from './addCategoryChildPosition';
import { reducer as removeCategoryChildPositionReducer } from './removeCategoryChildPosition';
import { reducer as chooseCurrentCompanyPositionNameTypeReducer } from './chooseCurrentCompanyPositionNameType';
import { reducer as tagModalChangeReducer } from './tagModalChange';
import { reducer as companyPositionModalChangeReducer } from './companyPositionModalChange';
import { reducer as companyPositionListModalChangeReducer } from './companyPositionListModalChange';
import { reducer as submitPositionListTypeReducer } from './submitPositionListType';
import { reducer as submitPositionNameTypeReducer } from './submitPositionNameType';
import { reducer as chooseCurrentCompanyPositionListReducer } from './chooseCurrentCompanyPositionList';
import { reducer as positionColTempModalChangeReducer } from './positionColTempModalChange';
import { reducer as templateModalChangeReducer } from './templateModalChange';
import { reducer as chooseCuTemplateReducer } from './chooseCuTemplate';
import { reducer as submitTemplateModifyTypeReducer } from './submitTemplateModifyType';
import { reducer as addCurrentTagsReducer } from './addCurrentTags';
import { reducer as submitdelTagReducer } from './submitdelTag';
import { reducer as tagssModalChangeReducer } from './tagssModalChange';
import { reducer as getChildPositionListReducer } from './getChildPositionList';

const reducers = [
  getIndustryTypeListReducer,
  submitIndustryTypeReducer,
  deleteIndustryTypeReducer,
  industryTypeModalChangeReducer,
  chooseCurrentIndustryTypeReducer,
  getWorkExperienceListReducer,
  submitWorkExperienceReducer,
  deleteWorkExperienceReducer,
  workExperienceModalChangeReducer,
  chooseCurrentWorkExperienceReducer,
  getSalaryTypeListReducer,
  submitSalaryTypeReducer,
  deleteSalaryTypeReducer,
  salaryTypeModalChangeReducer,
  chooseCurrentSalaryTypeReducer,
  getSalaryRangeListReducer,
  submitSalaryRangeReducer,
  deleteSalaryRangeReducer,
  salaryRangeModalChangeReducer,
  chooseCurrentSalaryRangeReducer,
  getUserTagListReducer,
  submitUserTagReducer,
  deleteUserTagReducer,
  userTagModalChangeReducer,
  chooseCurrentUserTagReducer,
  getCertTypeListReducer,
  submitCertTypeReducer,
  deleteCertTypeReducer,
  certTypeModalChangeReducer,
  chooseCurrentCertTypeReducer,
  getBenefitsListReducer,
  submitBenefitsReducer,
  deleteBenefitsReducer,
  benefitsModalChangeReducer,
  chooseCurrentBenefitsReducer,
  getEduListReducer,
  submitEduReducer,
  deleteEduReducer,
  eduModalChangeReducer,
  chooseCurrentEduReducer,
  getAreaListReducer,
  submitAreaReducer,
  deleteAreaReducer,
  areaModalChangeReducer,
  chooseCurrentAreaReducer,
  getCompanyTypeListReducer,
  submitCompanyTypeReducer,
  deleteCompanyTypeReducer,
  companyTypeModalChangeReducer,
  chooseCurrentCompanyTypeReducer,
  getPositionTypeListReducer,
  submitPositionTypeReducer,
  deletePositionTypeReducer,
  positionTypeModalChangeReducer,
  chooseCurrentPositionTypeReducer,
  addListActionReducer,
  getAllPositionTypeReducer,
  getAllCertTypeReducer,
  getAllSalaryTypeReducer,
  getAllUserTagReducer,
  getAllCompanyTypeReducer,
  getAllAreaReducer,
  getAllIndustryTypeReducer,
  getAllEduReducer,
  getAllExperienceReducer,
  getAllBenifitsReducer,
  getPositionCategoryReducer,
  getAllChildPostionReducer,
  getPositionListwithCaterogyReducer,
  addCategoryChildPositionReducer,
  removeCategoryChildPositionReducer,
  chooseCurrentCompanyPositionNameTypeReducer,
  tagModalChangeReducer,
  companyPositionModalChangeReducer,
  companyPositionListModalChangeReducer,
  submitPositionListTypeReducer,
  submitPositionNameTypeReducer,
  chooseCurrentCompanyPositionListReducer,
  positionColTempModalChangeReducer,
  templateModalChangeReducer,
  chooseCuTemplateReducer,
  submitTemplateModifyTypeReducer,
  addCurrentTagsReducer,
  submitdelTagReducer,
  tagssModalChangeReducer,
  getChildPositionListReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/system/redux/reducer.js